import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IReisekostenabrechnungStatiQueryShapes, ReisekostenabrechnungStatiQueryFilterConfig } from 'fa-kt.types';
import { ReisekostenabrechnungStatiService } from '../service';

@Component({
  selector: 'fa-kt-reisekostenabrechnung-stati-filter',
  templateUrl: './reisekostenabrechnung-stati-filter.component.html',
  styleUrls: ['./reisekostenabrechnung-stati-filter.component.css'],
})
export class ReisekostenabrechnungStatiFilterComponent {
  readonly subscriptions: Subscription[] = [];

  ReisekostenabrechnungStatiFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public reisekostenabrechnungStati: ReisekostenabrechnungStatiService,
  ) {
    this.ReisekostenabrechnungStatiFilterConfig = ReisekostenabrechnungStatiQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.reisekostenabrechnungStati.shapes$.subscribe((shapes: IReisekostenabrechnungStatiQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ReisekostenabrechnungStatiFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ReisekostenabrechnungStatiFilterConfig[index].selections = shapes;
  }
}
